module.exports = __webpack_public_path__ + "img/infoq-meeting.8f1b3c61.png";